import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { InfiniteScrollStore } from '../../../../../shared/store/common/infinite-scroll.store';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { routeParams } from '../../../../../shared/shared.global-service';

@Injectable()
export class ServiceDoctorRecordTypeModalStore extends ComponentStoreV2Factory {

    public procedures = computed(() => {
        return new InfiniteScrollStore(
            this.api.getServiceMedicalProcedures,
            FilterBuilder.singlePage({ serviceId: routeParams.serviceId(), active: true }),
        );
    });

}
